
import '../css/reset.css';
import '../css/whatever.css';

import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';

/**
 * @fileoverview 充值入口
 * @filetype ES6
 * @author zhenn
 */

class Download  extends Component {
    
    query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || 'search',
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]); 
        }
        return null;
    }

    getSystem() {
        var ua = navigator.userAgent;
        return /(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc';
    }

    getPlatform() {
        var ua = navigator.userAgent;
        var pl = 'other';

        if(ua.match(/pengpeng/i)){
            pl = 'pp';              
        } else if(ua.match(/micromessenger/i)){
            pl = 'wechat';
        } else if(ua.match(/qq/i)){
            pl = 'qq';
        } else if(ua.match(/weibo/i)){
            pl = 'weibo';
        } else if(ua.match(/renren/i)){
            pl = 'renren';
        }

        return pl;
    }

    download = ()=>{
        let self = this;
        let res = this.query('res'),
            system = self.getSystem(),
            pl = self.getPlatform(),
            _url;

        if (pl == 'wechat') {
            _url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.asiainno.uplive';
        } else {

            // ios版本
            if (system == 'ios') {
                _url = 'https://itunes.apple.com/us/app/up-zhi-bo/id1102727568';
            } else {
                // android版本

                if (res) {
                    // 百度sem
                    if (res.indexOf('UPsem') >= 0) {
                        _url = 'http://n.cdn.pengpengla.com/android/UpLive_2016.11.19_1.6.5_3130.production_global' + res + '.apk';
                    } else if (res.indexOf('UC') == 0) {
                        _url = 'http://n.cdn.pengpengla.com/android/UpLive_2016.11.19_1.6.5_3130.production_globalUc.apk';
                    } else if (res.indexOf('diankai') == 0) {

                        _url = 'http://n.cdn.pengpengla.com/android%2FUpLive_2016.07.20_1.2.1_1413.production_diankai1.apk';
                    } else if (res.indexOf('liebao') == 0) {
                        _url = 'http://n.cdn.pengpengla.com/android%2FUpLive_2016.07.21_1.2.1_1413.production_liebao.apk';
                    } else if (res.indexOf('xiaomixinxiliu') == 0) {
                        _url = 'http://n.cdn.pengpengla.com/android%2FUpLive_2016.07.21_1.2.1_1413.production_xiaomixinxiliu.apk';
                    } else if(res == 'qq'){
                        _url = 'http://n.cdn.pengpengla.com/android/UpLive_2016.09.27_1.5.2_2329.production_qq.apk';
                    }else if (res == 'aika') {
                        _url = 'http://n.cdn.pengpengla.com/UpLive_2016.11.03_1.6.1_2862.production_globalAika.apk';
                    } else{
                        _url = 'http://n.cdn.pengpengla.com/android/UpLive_2016.09.22_1.5.0_2304.production_yzl.apk';
                    }
                } else {
                    _url = 'http://n.cdn.pengpengla.com/android/UpLive_2016.09.22_1.5.0_2304.production_yzl.apk';
                }
                
            }   

        }
        location.href = _url;
    }

    render() {
        let self = this;
        let res = self.query('res') || '';
        return (
            <div>
                <div className="j1">
                    <img src={require('../images/bigpic.jpg')} />
                </div>
                <p className="selfplay" onClick={()=>self.download()}>
                </p>

                <div className="extrainfo" style={{fontSize: '0.3125rem', padding: '0.3125rem 0.3125rem 0.625rem'}}>
                    <p>Conact Us：upcs@asiainnovations.com</p>
                    <p>©️2016 Asia Innovations HK Limited. All Rights Reserved.</p>
                </div>
            </div>
        );
    
        
    }

}

render(<Download />, $('#wrap')[0]);





/** WEBPACK FOOTER **
 ** ./js/app.js
 **/